export default [
    { 
        label: 'Albanien', 
        value: 'AL',
    },
    { 
        label: 'Andorra', 
        value: 'AD', 
    },
    { 
        label: 'Belgien', 
        value: 'BE',
    },
    { 
        label: 'Bosnien und Herzegowina', 
        value: 'BA',
    },
    { 
        label: 'Bulgarien', 
        value: 'BG',
    },
    { 
        label: 'Dänemark', 
        value: 'DK',
    },
    { 
        label: 'Deutschland', 
        value: 'DE',
    },
    { 
        label: 'Estland', 
        value: 'EE',
    },
    { 
        label: 'Finnland', 
        value: 'FI',
    },
    { 
        label: 'Frankreich', 
        value: 'FR',
    },
    { 
        label: 'Griechenland', 
        value: 'GR',
    },
    { 
        label: 'Großbritannien', 
        value: 'GB',
    },
    { 
        label: 'Irland', 
        value: 'IE',
    },
    { 
        label: 'Italien', 
        value: 'IT',
    },
    { 
        label: 'Kosovo', 
        value: 'XK',
    },
    { 
        label: 'Kroatien', 
        value: 'HR',
    },
    { 
        label: 'Lettland', 
        value: 'LV',
    },
    { 
        label: 'Liechtenstein', 
        value: 'LI',
    },
    { 
        label: 'Luxemburg', 
        value: 'LU',
    },
    { 
        label: 'Moldau', 
        value: 'MD',
    },
    { 
        label: 'Monaco', 
        value: 'MC',
    },
    { 
        label: 'Montenegro', 
        value: 'ME',
    },
    { 
        label: 'Niederlande', 
        value: 'NL',
    },
    { 
        label: 'Nordmazedonien', 
        value: 'MK',
    },
    { 
        label: 'Norwegen', 
        value: 'NO',
    },
    { 
        label: 'Polen', 
        value: 'PL',
    },
    { 
        label: 'Portugal', 
        value: 'PT',
    },
    { 
        label: 'Rumänien', 
        value: 'RO',
    },
    { 
        label: 'Russland', 
        value: 'RU',
    },
    { 
        label: 'San Marino', 
        value: 'SM',
    },
    { 
        label: 'Schweden', 
        value: 'SE',
    },
    { 
        label: 'Schweiz', 
        value: 'CH',
    },
    { 
        label: 'Serbien', 
        value: 'RS',
    },
    { 
        label: 'Slowakei', 
        value: 'SK',
    },
    { 
        label: 'Slowenien', 
        value: 'SI',
    },
    { 
        label: 'Spanien', 
        value: 'ES',
    },
    { 
        label: 'Tschechien', 
        value: 'CZ',
    },
    { 
        label: 'Türkei', 
        value: 'TR',
    },
    { 
        label: 'Ukraine', 
        value: 'UA',
    },
    { 
        label: 'Ungarn', 
        value: 'HU',
    },
    { 
        label: 'Weißrussland (Belarus)', 
        value: 'BY',
    },
];